import { article as articleData } from "shared/data";

import type { ContentTypeEnum } from "scmp-app/queries/__generated__/searchArticleResultPaginationQuery.graphql";

export type TypeOption = {
  isContentType?: boolean;
  text: string;
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  value: Array<ContentTypeEnum | string>;
};

export const TypeOptions: TypeOption[] = [
  {
    isContentType: true,
    text: "Article",
    value: ["ARTICLE"],
  },
  {
    text: "Opinion",
    value: [articleData.types.opinion.entityUuid, articleData.types.column.entityUuid],
  },
  {
    text: "Live",
    value: [articleData.types.live.entityUuid],
  },
  {
    text: "Explainer",
    value: [articleData.types.explainer.entityUuid],
  },
  {
    isContentType: true,
    text: "Video",
    value: ["VIDEO"],
  },
  {
    isContentType: true,
    text: "Gallery",
    value: ["GALLERY"],
  },
];
